(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/next/utils/utils.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/next/utils/utils.js');
"use strict";

const _React = React,
  useEffect = _React.useEffect;
const classListCache = {};
const branding = svs.tickets.data.templateConfig.branding;
const mapProductType = svs.ticketgames.ticketMappings.productMappings.mapProductType;
const formatCurrency = svs.utils.format.Currency;
const calloutFont = '700 18px "Svenska Spel Arena Pro", "Svenska Spel Plan Pro", sans-serif';
let calloutMeasureContext;
const formatCalloutPrices = line => line.replace(/(\d(?:[\d\s]*\d)?(?:[.,]\d+)?)\s*(KR)(?=\s*\/|\b)/gi, (match, price, currency) => "".concat(formatCurrency(price.trim()), " ").concat(currency));
const getCalloutLines = label => String(label || '').replace(/\r\n?/g, '\n').replace(/\s*\|\s*/g, '\n').split('\n').map(line => line.trim()).filter(Boolean).map(formatCalloutPrices).slice(0, 2);
const getCalloutAlignment = lines => {
  if (lines.length < 2) {
    return null;
  }
  if (typeof document === 'undefined') {
    return lines[0].length >= lines[1].length ? 'top' : 'bottom';
  }
  if (!calloutMeasureContext) {
    calloutMeasureContext = document.createElement('canvas').getContext('2d');
  }
  if (!calloutMeasureContext) {
    return lines[0].length >= lines[1].length ? 'top' : 'bottom';
  }
  calloutMeasureContext.font = calloutFont;
  return calloutMeasureContext.measureText(lines[0]).width >= calloutMeasureContext.measureText(lines[1]).width ? 'top' : 'bottom';
};
const setTabIndexOnButton = (button, remove) => {
  if (button) {
    button.tabIndex = remove ? -1 : 0;
  }
};
const hideHeader = function () {
  let topContentHeight = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  const backNav = document.querySelector('.navigation-back-next-lobby');
  const background = document.querySelector('.js-triss-background');
  if (backNav) {
    const heightDiff = backNav.clientHeight + topContentHeight;
    gsap.to(backNav, 1, {
      y: -heightDiff
    });
    backNav.querySelectorAll('button').forEach(button => {
      setTabIndexOnButton(button, true);
    });
  }
  const topNavHeight = topContentHeight;
  gsap.to(background, 1, {
    marginTop: -topNavHeight,
    marginBottom: -topNavHeight
  });
};
const hideTopHeader = () => {
  const reactContainer = document.querySelector('.js-react-container');
  const fixedTopContent = document.querySelector('.js-fixed-top-content');
  const aoBrand = document.querySelector('.corporate-info-ao-brand');
  const profileIconButton = document.querySelector('.js-nav-user');
  const navHamburgerButton = document.querySelector('.js-nav-hamburger');
  const topContent = document.querySelector('#top-content');
  const heightDiff = topContent.clientHeight;
  const previousBoxShadow = getComputedStyle(topContent).boxShadow;
  topContent.dataset.previousBoxShadow = previousBoxShadow;
  topContent.style.boxShadow = 'none';
  topContent.style.backgroundColor = '#FFD118';
  hideHeader(topContent.clientHeight);
  gsap.to(aoBrand, 1, {
    y: -heightDiff
  });
  gsap.to(topContent, 1, {
    y: -heightDiff,
    onComplete: () => {
      topContent.style.backgroundColor = '';
    }
  });
  gsap.to(navHamburgerButton, 1, {
    y: -heightDiff,
    onComplete: () => {
      setTabIndexOnButton(navHamburgerButton, true);
    }
  });
  gsap.to(profileIconButton, 1, {
    y: -heightDiff,
    onComplete: () => {
      setTabIndexOnButton(profileIconButton, true);
    }
  });
  fixedTopContent.style.height = null;
  reactContainer.style.minHeight = "calc(100vh - ".concat(fixedTopContent.clientHeight + heightDiff, "px)");
  fixedTopContent.style.height = "".concat(fixedTopContent.clientHeight - heightDiff, "px");
};
const showHeader = () => {
  const backNav = document.querySelector('.navigation-back-next-lobby');
  const background = document.querySelector('.js-triss-background');
  backNav && gsap.to(backNav, {
    duration: 1,
    y: 0
  });
  gsap.to(background, {
    duration: 1,
    marginTop: 0,
    marginBottom: 0
  });
  backNav === null || backNav === void 0 || backNav.querySelectorAll('button').forEach(button => {
    setTabIndexOnButton(button, false);
  });
};
const showTopHeader = gameFinished => {
  const reactContainer = document.querySelector('.js-react-container');
  const fixedTopContent = document.querySelector('.js-fixed-top-content');
  const aoBrand = document.querySelector('.corporate-info-ao-brand');
  const profileIconButton = document.querySelector('.js-nav-user');
  const navHamburgerButton = document.querySelector('.js-nav-hamburger');
  const topContent = document.querySelector('#top-content');
  const previousBoxShadow = topContent.dataset.previousBoxShadow;
  topContent.style.boxShadow = previousBoxShadow || '';
  const heightDiff = topContent.clientHeight;
  gsap.to(topContent, {
    duration: 1,
    y: 0
  });
  gsap.to(aoBrand, 1, {
    y: 0
  });
  gsap.to(navHamburgerButton, {
    duration: 1,
    y: 0,
    onComplete: () => {
      setTabIndexOnButton(navHamburgerButton, false);
    }
  });
  gsap.to(profileIconButton, {
    duration: 1,
    y: 0,
    onComplete: () => {
      setTabIndexOnButton(profileIconButton, false);
    }
  });
  fixedTopContent.style.height = null;
  if (gameFinished) {
    var _getComputedStyle;
    const contentHeight = (_getComputedStyle = getComputedStyle(document.body)) === null || _getComputedStyle === void 0 ? void 0 : _getComputedStyle.getPropertyValue('--availableContentHeight');
    reactContainer.style.minHeight = contentHeight;
    return;
  }
  reactContainer.style.minHeight = "calc(100vh - ".concat(fixedTopContent.clientHeight + heightDiff, "px)");
};
const updateContainedSize = _ref => {
  let container = _ref.container,
    target = _ref.target,
    width = _ref.width,
    height = _ref.height;
  if (!container || !target || !width || !height) {
    return null;
  }
  const containerWidth = container.clientWidth;
  const containerHeight = container.clientHeight;
  if (!containerWidth || !containerHeight) {
    return null;
  }
  const aspectRatio = width / height;
  const containerRatio = containerWidth / containerHeight;
  let nextWidth = containerWidth;
  let nextHeight = containerWidth / aspectRatio;
  if (containerRatio > aspectRatio) {
    nextHeight = containerHeight;
    nextWidth = containerHeight * aspectRatio;
  }
  const boundedWidth = Math.min(containerWidth, Math.ceil(nextWidth));
  const boundedHeight = Math.min(containerHeight, Math.ceil(nextHeight));
  target.style.width = "".concat(boundedWidth, "px");
  target.style.height = "".concat(boundedHeight, "px");
  return {
    width: boundedWidth,
    height: boundedHeight,
    containerWidth,
    containerHeight
  };
};
const onBreakPointChange = () => {
  if (svs.core.detect.breakpoint.greaterThan('md')) {
    hideHeader();
    showTopHeader();
  } else {
    hideTopHeader();
  }
};
const getCampaignTicketType = () => {
  var _svs$tickets$data$mod;
  return (_svs$tickets$data$mod = svs.tickets.data.moduleConfig) === null || _svs$tickets$data$mod === void 0 || (_svs$tickets$data$mod = _svs$tickets$data$mod.ticketsContentList) === null || _svs$tickets$data$mod === void 0 ? void 0 : _svs$tickets$data$mod.campaignTicketType;
};
const getCampaignTicketCallout = ticketInfo => {
  var _svs$tickets$data$mod2;
  if (!ticketInfo || ticketInfo.type !== getCampaignTicketType()) {
    return;
  }
  return (_svs$tickets$data$mod2 = svs.tickets.data.moduleConfig) === null || _svs$tickets$data$mod2 === void 0 || (_svs$tickets$data$mod2 = _svs$tickets$data$mod2.campaignTicket) === null || _svs$tickets$data$mod2 === void 0 ? void 0 : _svs$tickets$data$mod2.callout;
};
const getCampaignTicket = () => {
  var _svs$tickets$data$mod3;
  const availableTickets = ((_svs$tickets$data$mod3 = svs.tickets.data.moduleConfig) === null || _svs$tickets$data$mod3 === void 0 ? void 0 : _svs$tickets$data$mod3.availableTickets) || [];
  const campaignTicketType = getCampaignTicketType();
  if (campaignTicketType) {
    return availableTickets.find(ticketInfo => ticketInfo.type === campaignTicketType);
  }
};
const getBackFaceTicketTitle = _ref2 => {
  let name = _ref2.name,
    price = _ref2.price,
    type = _ref2.type;
  const ticketName = name || type || '';
  const priceLabel = price ? "".concat(price, " kr") : '';
  if (!ticketName || !priceLabel || ticketName.toLowerCase().endsWith(priceLabel.toLowerCase())) {
    return ticketName;
  }
  if (ticketName.endsWith("".concat(price))) {
    return "".concat(ticketName, " kr");
  }
  return "".concat(ticketName, " ").concat(priceLabel);
};
setGlobal('svs.tickets.next.utils.utils', {
  getBackFaceTicketTitle,
  getCalloutAlignment,
  getCalloutLines,
  getCampaignTicketCallout,
  selectSnappedElement: (element, className) => {
    if (!classListCache[className]) {
      classListCache[className] = document.getElementsByClassName(className);
    }
    const classList = classListCache[className];
    const classDistance = classList && classList.length > 1 ? classList[1].offsetLeft - classList[0].offsetLeft : 1;
    const leftScroll = element.scrollLeft || 1;
    const count = Math.round(leftScroll / classDistance);
    if (leftScroll < 2) {
      return classList[0];
    }
    return classList[count];
  },
  useMainContentBg: ticketInfo => {
    useEffect(() => {
      var _ticketInfo$customBg;
      if (!ticketInfo) {
        return;
      }
      const content = document.querySelector('.js-main-content');
      const className = branding === 'triss' ? 'bg-triss-200' : "bg-skrapspel-".concat(mapProductType(ticketInfo.type));
      if (ticketInfo !== null && ticketInfo !== void 0 && (_ticketInfo$customBg = ticketInfo.customBg) !== null && _ticketInfo$customBg !== void 0 && _ticketInfo$customBg.image) {
        var _ticketInfo$customBg2;
        content.style.background = "url(".concat(svs.core.config.data.svsconfig.cdn2).concat(ticketInfo === null || ticketInfo === void 0 || (_ticketInfo$customBg2 = ticketInfo.customBg) === null || _ticketInfo$customBg2 === void 0 ? void 0 : _ticketInfo$customBg2.image.url, ")");
      }
      content.classList.add(className);
      return () => {
        content.classList.remove(className);
        content.style.background = '';
      };
    }, [ticketInfo]);
  },
  getTicketInfo: (ticketType, ticketConfigs) => _.find(ticketConfigs, product => product.type.toLowerCase() === (ticketType === null || ticketType === void 0 ? void 0 : ticketType.toLowerCase())) || {
    isNotConfigured: true
  },
  getMenuProduct: (ticketType, products) => {
    const matchesAlternativeUrl = product => {
      var _product$alternativeU;
      return ((_product$alternativeU = product.alternativeUrl) === null || _product$alternativeU === void 0 ? void 0 : _product$alternativeU.toLowerCase()) === (ticketType === null || ticketType === void 0 ? void 0 : ticketType.toLowerCase());
    };
    const matchesType = product => product.type.toLowerCase() === (ticketType === null || ticketType === void 0 ? void 0 : ticketType.toLowerCase());
    return _.find(products, product => matchesAlternativeUrl(product) || matchesType(product)) || {
      isNotInLobby: true
    };
  },
  getTicketNameStyle: (ticketWidth, ticketHeight) => {
    if (!ticketWidth || !ticketHeight) {
      return;
    }
    let adjustedTicketWidth = ticketWidth;
    if (adjustedTicketWidth > ticketHeight * 0.8) {
      adjustedTicketWidth = ticketHeight * 0.6;
    }
    const fontSize = Math.min(24, Math.max(8, adjustedTicketWidth * 0.06));
    return fontSize < 10 ? {
      fontSize,
      top: 6
    } : {
      fontSize
    };
  },
  observeContainedSize: _ref3 => {
    let container = _ref3.container,
      target = _ref3.target,
      width = _ref3.width,
      height = _ref3.height,
      onUpdate = _ref3.onUpdate;
    if (!container || !target || !width || !height) {
      return () => {};
    }
    const updateSize = () => {
      const nextSize = updateContainedSize({
        container,
        target,
        width,
        height
      });
      if (nextSize && onUpdate) {
        onUpdate(nextSize);
      }
    };
    updateSize();
    if (window.ResizeObserver) {
      const resizeObserver = new ResizeObserver(updateSize);
      resizeObserver.observe(container);
      return () => {
        resizeObserver.disconnect();
        target.style.removeProperty('width');
        target.style.removeProperty('height');
      };
    }
    window.addEventListener('resize', updateSize);
    return () => {
      window.removeEventListener('resize', updateSize);
      target.style.removeProperty('width');
      target.style.removeProperty('height');
    };
  },
  hideFooter: () => {
    document.querySelector('.page-footer').classList.add('hide-page-footer');
  },
  showFooter: () => {
    document.querySelector('.page-footer').classList.remove('hide-page-footer');
  },
  hideHeaders: shouldHideTopHeader => {
    if (shouldHideTopHeader) {
      onBreakPointChange();
      svs.core.detect.breakpoint.on('change', onBreakPointChange);
    } else {
      hideHeader();
    }
  },
  showHeaders: function () {
    let shouldShowTopHeader = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    svs.core.detect.breakpoint.off('change', onBreakPointChange);
    showHeader();
    if (shouldShowTopHeader) {
      showTopHeader(true);
    }
  },
  getTicketVariations: ticketInfo => {
    const variations = ticketInfo.variations;
    if (variations) {
      return parseInt(variations, 10);
    }
    return 0;
  },
  getSelectedTicketVariation: (selectedNumber, ticketInfo) => {
    const skinVariations = svs.tickets.next.utils.utils.getTicketVariations(ticketInfo);
    if (skinVariations) {
      return (selectedNumber - 1) % parseInt(skinVariations, 10) + 1;
    }
    return 0;
  },
  scrollTopContent: () => {
    $('html').animate({
      scrollTop: 0
    }, 250);
  },
  stashTicket: nb => {
    svs.components.Storage.browser.set('ticketNb', 'tickets', nb);
  },
  getTicketStash: () => svs.components.Storage.browser.get('ticketNb', 'tickets'),
  clearTicketStash: () => {
    svs.components.Storage.browser.remove('ticketNb', 'tickets');
  },
  getTicketTypeFromWager: wagerId => {
    let game;
    if (wagerId === 'pagaende') {
      game = svs.tickets.data.fetchedGames[0];
    } else {
      game = svs.tickets.data.fetchedGame;
    }
    return {
      ticketType: game.properties.externalProductCode,
      wagerId: game.properties.externalWagerId,
      gameIsCompleted: game.completed
    };
  },
  redirectToOngoing: () => {
    svs.utils.url.navigate("".concat(svs.core.data.baseUrl, "/mina-spel/pagaende"));
  },
  getCampaignTicketType,
  getCampaignTicket
});

 })(window);